import axios from 'axios';

const API_URL_NOTI_SERVICE = process.env.VUE_APP_API_URL_NOTI_SERVICE;
const VUE_APP_BACK_URL = process.env.VUE_APP_BACK_URL;
let accessToken = null;

export async function getToken() {
    const url = `${VUE_APP_BACK_URL}oauth2/token/`;
    const data = new FormData();
    data.append('client_id', `${process.env.VUE_APP_CLIENT_ID}`);
    data.append('client_secret', `${process.env.VUE_APP_CLIENT_SECRET}`);
    data.append('grant_type', 'client_credentials');

    try {
        const response = await axios.post(url, data);
        accessToken = response.data.access_token;
        return accessToken;
    } catch (error) {
        console.error('Error al obtener el token:', error);
        throw error;
    }
}

async function ensureToken() {

        await getToken();

}

async function securedPost(url, data) {
    await ensureToken();
    return await axios.post(url, data, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`
        }
    });
}

export async function emailAlumnosTodoColegioNoUso(data) {
    const url = `${API_URL_NOTI_SERVICE}estudyoo/email/alumnos-todo-colegio-no-uso/`;
    return await securedPost(url, data);
}

// Email con estadísticas de uso opción A
export async function emailEstadisticasAlumnoOpcionA(data) {
    const url = `${API_URL_NOTI_SERVICE}estudyoo/email/estadisticas-alumno-opcion-a/`;
    return await securedPost(url, data);
}

// Email a un alumno que no ha usado el sistema
export async function emailNoUsoAlumno(data) {
    const url = `${API_URL_NOTI_SERVICE}estudyoo/email/alumno-no-uso/`;
    return await securedPost(url, data);
}

// Push de no uso por colegio
export async function pushNoUsoPorColegio(data) {
    const url = `${API_URL_NOTI_SERVICE}estudyoo/push/usuarios-no-uso-por-colegio/`;
    return await securedPost(url, data);
}

// Push lista de usuarios que no han usado el sistema
export async function pushListaUsuariosNoUso(data) {
    const url = `${API_URL_NOTI_SERVICE}estudyoo/push/lista-usuarios-no-uso/`;
    return await securedPost(url, data);
}

// Push a un usuario que no ha usado el sistema
export async function pushNoUsoUsuario(data) {
    const url = `${API_URL_NOTI_SERVICE}estudyoo/push/usuario-no-uso/`;
    return await securedPost(url, data);
}

// Exportar funciones
export default {
    emailAlumnosTodoColegioNoUso,
    emailEstadisticasAlumnoOpcionA,
    emailNoUsoAlumno,
    pushNoUsoPorColegio,
    pushListaUsuariosNoUso,
    pushNoUsoUsuario,
};